/* Sign-up form helpers (inline in menu shell). */
(function () {
    window.MDMeals = window.MDMeals || {};
})();
